import React, { Component } from "react";
import { connect } from "react-redux";

import { runSearchQuery } from "../actions/searchActions";
import { getEverythingForSearchPage } from "../actions/searchActions";
import { getSignedUrlAndDownload } from "../actions/documentActions";
import { setForcePagination } from "../actions/globalScreenSizeActions";
import { setComponent } from "../actions/globalPaginationActions";
import {
	toggleDropdownSelectShowAll,
	toggleTopMattersSearchResults,
} from "../actions/browserLocalstorageActions";
import { LoadingBlocker } from "./UnderSubHeader";
import { SearchResults, AggregationResults } from "./SearchResults";
import { LabeledTextInput } from "./TextInput";
import { ButtonWithIcon } from "./ButtonWithIcon";
import { LabeledDropDownSelect } from "./DropDownSelect";
import UsersDropDownSelect from "./UsersDropDownSelect";
import { LabeledDatePicker } from "./LabeledDatePicker";
import { LabeledSwitch } from "./AsyncSwitch";
import MaterialTabs from "./MaterialTabs";
import queryString from "query-string";
import config from "../config/legalworks.frontend.config";
import { IconSearch } from "@tabler/icons-react";
import { numberWithCommas } from "../utilities/utilities";
import {
	orderingOptions,
	docSearchModeOptions,
	searchStateDefaults,
	parseSearchUrlParams,
	serializeSearchUrlParams,
} from "./Search/searchUrlParams";

const recordTypeMap = {
	docs: { display: "Document" },
	email: { display: "Email" },
	matterNote: { display: "Matter Note" },
};

const makeDefaultFileExtensionFilterSelection = (
	fileExtensionFilterOptions,
	fileExtensionFilter
) => {
	return fileExtensionFilterOptions.filter(
		(allowedOption) =>
			fileExtensionFilter &&
			fileExtensionFilter.find(
				(providedFilter) => providedFilter.value === allowedOption.value
			)
	);
};

const makeDefaultUsersFilterSelection = (users, usersFilterByID) => {
	var selectedItems = [];
	usersFilterByID &&
		usersFilterByID.forEach((userFilter) => {
			var thisUser = users.filter((u) => u.id === userFilter.id);
			if (thisUser.length) {
				selectedItems.push({
					label: thisUser[0].displayName,
					value: thisUser[0].sub,
					id: thisUser[0].id,
				});
			}
		});
	return selectedItems.length ? selectedItems : null;
};

const makeDefaultSelection = (documentTypeNames, documentTypeFilter) => {
	var selectedItems = [];
	documentTypeFilter &&
		documentTypeFilter.forEach((typeID) => {
			if (documentTypeNames[typeID.id]) {
				selectedItems.push({
					id: typeID.id,
					label: documentTypeNames[typeID.id],
					value: documentTypeNames[typeID.id],
				});
			}
		});
	return selectedItems;
};
const makeDefaultMatterFilterSelection = (mattersList, matterFilter) => {
	const allMatters = mattersList;
	var defaultSelection = [];
	matterFilter &&
		matterFilter.forEach((m) => {
			var matterName = allMatters.filter((list) => list.id === m.id);
			if (matterName.length) {
				var config = {
					id: m.id,
					label: matterName[0].name,
					value: m.id,
				};
				defaultSelection.push(config);
			}
		});
	return defaultSelection;
};
const makeDefaultOrderingSelection = (orderingValue) => {
	return orderingValue
		? orderingOptions.filter(
				(allowedOption) => allowedOption.id === orderingValue.id
			)[0]
		: orderingOptions[0];
};

const makeDefaultdocSearchModeSelection = (searchModeValue) => {
	return (
		docSearchModeOptions.find(
			(option) => option.id === searchModeValue.id
		) || docSearchModeOptions[0]
	);
};

const makeUserOptions = (users) => {
	return users.map((user) => {
		return {
			label: user.displayName,
			value: user.sub,
			id: user.id,
			type: user.type,
			status: user.status,
		};
	});
};

const SearchInstructions = () => {
	return (
		<div>
			<span>
				LexWorkplace Search supports advanced operators like AND, OR,
				NOT and more.
			</span>
			<a
				style={{ marginLeft: 4 }}
				target="_blank"
				rel="noopener noreferrer"
				href="https://help.lexworkplace.com/docs/search-advanced"
			>
				Learn more.
			</a>
		</div>
	);
};

class Search extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			...searchStateDefaults(),
			executedQuery: "",
			loadedFromUrl: false,
			runAfterNavigating: false,
		};
		this.submit = this.submit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.updateUrlParams = this.updateUrlParams.bind(this);
		this.toggleSearchFavorites = this.toggleSearchFavorites.bind(this);
		this.toggleSearchIncludeDeleted =
			this.toggleSearchIncludeDeleted.bind(this);
		this.handleTabChange = this.handleTabChange.bind(this);
	}
	static getDerivedStateFromProps(props, state) {
		if (!state.loadedFromUrl) {
			const queryStringValues = queryString.parse(props.location.search);
			return {
				...state,
				loadedFromUrl: true,
				...parseSearchUrlParams(queryStringValues),
				runAfterNavigating: "runAfterNavigating" in queryStringValues,
			};
		} else {
			return null;
		}
	}
	submit(e, startPage = 1) {
		const {
			matterFilter,
			docSearchMode,
			fromDate,
			toDate,
			documentTypeFilter,
			documentStatusFilter,
			documentTagsFilter,
			usersFilter,
			usersLockFilter,
			onlySearchMyFavorites,
			includeDeletedItemsInSearch,
			ordering,
			query,
		} = this.state;
		if (!this.props.helperDataLoaded) {
			return;
		} else {
			this.props.runSearchQuery(
				query,
				{
					matterFilter: matterFilter && matterFilter.map((m) => m.id),
					docSearchMode: docSearchMode?.value || "docs",
					fromDate: fromDate && fromDate.toISOString(),
					toDate: toDate && toDate.toISOString(),
					documentTypeFilter:
						documentTypeFilter &&
						documentTypeFilter.map((t) => t.id),
					documentStatusFilter:
						documentStatusFilter &&
						documentStatusFilter.map((s) => s.id),
					documentTagsFilter:
						documentTagsFilter &&
						documentTagsFilter.map((t) => t.id),
					usersFilter:
						usersFilter &&
						usersFilter.map((t) => this.props.userSubsByID[t.id]),
					usersLockFilter:
						usersLockFilter &&
						usersLockFilter.map(
							(t) => this.props.userSubsByID[t.id]
						),
					onlySearchMyFavorites,
					includeDeletedItemsInSearch,
					ordering: ordering && ordering.id,
					fileExtensionFilter:
						this.state.fileExtensionFilter &&
						this.state.fileExtensionFilter.flatMap((t) => {
							const category =
								this.props.fileExtensionFilterOptions.find(
									(option) => option.value === t.value
								);
							return category ? category.extensions : [];
						}),
					activeTab:
						this.props.searchTabs?.[this.state.activeTab]?.alias ||
						"all",
				},
				startPage
				//if startPage is not provided, as is the case when clicking the button or
				//pressing enter in the search field, the search reverts back to page 1
			);

			this.setState({ executedQuery: query }, this.updateUrlParams);
		}
	}
	updateUrlParams() {
		const params = serializeSearchUrlParams(this.state);
		const search = Object.keys(params).length
			? "?" + new URLSearchParams(params).toString()
			: "";
		this.props.history.replace({
			pathname: "/search",
			search,
		});
	}
	componentDidMount() {
		this.props.setForcePagination(true);

		if (!this.props.hack || !this.props.helperDataLoaded) {
			//only used when navigating via URL, see the routes for /search in App.js for additional description
			this.props.getEverythingForSearchPage();
		}

		if (this.state.runAfterNavigating && this.props.helperDataLoaded) {
			// helper data already loaded (eg repeat search) - submit now
			this.setState({ runAfterNavigating: false }, this.submit);
		}
		this.props.setComponent(
			//this is a hack to get around redux reducer
			//not allowing functions with side effects.
			//There must be a more "correct" way to accomplish this?
			() =>
				setTimeout(() => {
					this.submit(false, this.props.currentPage);
				}, 30),
			0,
			config.searchResultsPerPage
		);
	}
	toggleSearchFavorites() {
		this.setState({
			onlySearchMyFavorites: !this.state.onlySearchMyFavorites,
		});
	}
	toggleSearchIncludeDeleted() {
		this.setState({
			includeDeletedItemsInSearch:
				!this.state.includeDeletedItemsInSearch,
		});
	}
	componentWillUnmount() {
		this.props.setForcePagination(false);
	}
	componentDidUpdate() {
		// helper data just finished loading - run the deferred search
		if (this.state.runAfterNavigating && this.props.helperDataLoaded) {
			this.setState({ runAfterNavigating: false }, this.submit);
		}
	}
	handleChange(key, value) {
		if (key === "toDate" || key === "fromDate") {
			// Convert the value to a Date object if it exists, otherwise set it to null
			value = value ? new Date(value) : null;
		}
		var newState = { [key]: value };
		this.setState(newState);
	}
	handleTabChange(tabIndex) {
		if (tabIndex === this.state.activeTab) {
			return;
		}
		this.setState({ activeTab: tabIndex }, () => {
			// we must fetch new results when switching tabs
			this.updateUrlParams();
			this.submit();
		});
	}
	render() {
		return (
			<div className="noDefaultMargin searchFullHeightDefault">
				{this.props.searchResultsLoading ||
				!this.props.helperDataLoaded ? (
					<LoadingBlocker />
				) : null}
				<div>
					<div
						style={{
							display: "flex",
							borderBottom: "1px solid",
							borderColor: "var(--lw-medium-grey-b)",
							padding: 28,
							paddingBottom: 16,
						}}
					>
						<div
							style={{
								flexGrow: 1,
								marginRight: 16,
							}}
						>
							<div>
								<LabeledTextInput
									name="query"
									label="Search"
									defaultValue={this.state.query}
									onChange={this.handleChange}
									onEnterKey={this.submit}
									placeholder="Search LexWorkplace"
									hoverText='Enter a word or phrase to search for.  Wrap words "in quotation marks" to search for an exact phrase.'
									invalid={this.props.lastQueryParseError}
								/>{" "}
								<SearchInstructions />
							</div>
						</div>
						<div style={{ marginTop: 22 }}>
							<ButtonWithIcon
								handler={this.submit}
								buttonText="Search"
								style={{ height: 38 }}
								iconComponent={
									<IconSearch
										size={16}
										style={{ verticalAlign: "sub" }}
									/>
								}
							/>
						</div>
					</div>

					<div
						className="searchLayoutRow"
						style={{
							display: "flex",
							aligSelf: "stretch",
						}}
					>
						<div
							className="searchFiltersSidebar"
							style={{
								width: 423,
								paddingLeft: 32,
								paddingRight: 32,
								paddingTop: 24,
								borderRight: "1px solid",
								borderColor: "var(--lw-medium-grey-b)",
								backgroundColor: "var(--lw-light-grey-a)",
								height: "100%",
								marginBottom: 40,
							}}
						>
							{this.props.helperDataLoaded && (
								<div>
									<div>
										<LabeledDropDownSelect
											label="Order By"
											name="ordering"
											defaultValue={makeDefaultOrderingSelection(
												this.state.ordering
											)}
											isAsync
											options={orderingOptions}
											handler={this.handleChange}
											hoverText="How to order search results."
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="Document Search Mode"
											name="docSearchMode"
											defaultValue={makeDefaultdocSearchModeSelection(
												this.state.docSearchMode
											)}
											isAsync
											options={docSearchModeOptions}
											handler={this.handleChange}
											hoverText="When searching for documents, choose whether to search both document file names and their content, or just file names."
										/>
									</div>
									<div>
										<LabeledSwitch
											upperLabel="Favorites"
											label="Only My Favorite Documents"
											switchValue={
												!!this.state
													.onlySearchMyFavorites
											}
											handleSwitchValueChange={
												this.toggleSearchFavorites
											}
										/>
									</div>
									<div>
										<LabeledSwitch
											upperLabel="Trash Bin"
											label="Include Items in the Trash Bin"
											switchValue={
												!!this.state
													.includeDeletedItemsInSearch
											}
											handleSwitchValueChange={
												this.toggleSearchIncludeDeleted
											}
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="Matter"
											name="matterFilter"
											placeholder="All Matters"
											isClearable
											isMulti
											isAsync
											defaultValue={makeDefaultMatterFilterSelection(
												this.props.mattersList,
												this.state.matterFilter
											)}
											options={this.props.mattersList
												// .filter(
												// 	type => type.status === "active"
												// )
												.map((matter) => ({
													label: matter.name,
													value: matter.id,
													id: matter.id,
												}))
												.sort((a, b) => {
													if (
														a.id === -1 ||
														a.id === 0 ||
														b.id === -1 ||
														b.id === 0
													) {
														//firm docs should go at top
														return a.id < b.id;
													} else {
														// non firm docs sorted in descending
														// id order (should be most recent matter at top)
														return b.id < a.id
															? -1
															: 1;
													}
												})}
											overLimitDisplayNoun={"matter"}
											handler={this.handleChange}
											hoverText="Specify which matter(s) your search should include."
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="File Type/Extension"
											name="fileExtensionFilter"
											placeholder="All File Extensions"
											defaultValue={makeDefaultFileExtensionFilterSelection(
												this.props
													.fileExtensionFilterOptions,
												this.state.fileExtensionFilter
											)}
											isClearable
											isMulti
											isAsync
											options={
												this.props
													.fileExtensionFilterOptions
											}
											handler={this.handleChange}
											hoverText="Select file extensions to filter the search results."
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="Document Type"
											name="documentTypeFilter"
											placeholder="Any Type"
											isClearable
											isMulti
											isAsync
											isDisabled={false}
											defaultValue={makeDefaultSelection(
												this.props.documentTypeNames,
												this.state.documentTypeFilter
											)}
											options={this.props.availableDocumentTypes
												// .filter(
												// 	type => type.status === "active"
												// )
												.map((type) => ({
													label: type.name,
													value: type.name,
													id: type.id,
												}))}
											handler={this.handleChange}
											hoverText="Specify which Document Types to include. Only those document types will appear in your search results."
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="Document Status"
											name="documentStatusFilter"
											placeholder="Any Status"
											isClearable
											isMulti
											isAsync
											isDisabled={false}
											defaultValue={makeDefaultSelection(
												this.props.documentStatusNames,
												this.state.documentStatusFilter
											)}
											options={this.props.availableDocumentStatuses
												// .filter(
												// 	type => type.status === "active"
												// )
												.map((type) => ({
													label: type.name,
													value: type.name,
													id: type.id,
												}))}
											handler={this.handleChange}
											hoverText="Specify which Document Statuses to include. Only documents with the selected statuses will appear in your search results."
										/>
									</div>
									<div>
										<LabeledDropDownSelect
											label="Document Tags"
											name="documentTagsFilter"
											placeholder="Any Tags"
											isClearable
											isMulti
											isAsync
											isDisabled={false}
											defaultValue={makeDefaultSelection(
												this.props.documentTagNames,
												this.state.documentTagsFilter
											)}
											options={this.props.availableDocumentTags
												// .filter(
												// 	type => type.status === "active"
												// )
												.map((type) => ({
													label: type.name,
													value: type.name,
													id: type.id,
												}))}
											handler={this.handleChange}
											hoverText="Specify which Document Tags to include. Only documents with these tags applied will appear in your search results."
										/>
									</div>
									<div>
										<UsersDropDownSelect
											label="Modified By"
											name="usersFilter"
											placeholder="Any User"
											isClearable
											isMulti
											isAsync
											isDisabled={false}
											defaultValue={makeDefaultUsersFilterSelection(
												this.props.users,
												this.state.usersFilter
											)}
											options={makeUserOptions(
												this.props.users
											)}
											handler={this.handleChange}
											hoverText="Only documents or matter notes which have been modified by the selected users will appear in your search results"
										/>
									</div>
									<div style={{ display: "flex" }}>
										<div style={{ marginRight: 8 }}>
											<LabeledDatePicker
												label="Modified Between"
												name="fromDate"
												defaultValue={(() => {
													return this.state.fromDate
														? new Date(
																this.state
																	.fromDate
															)
														: null;
												})()}
												isClearable
												placeholderText="Any time in the past"
												handler={this.handleChange}
												hoverText="For Documents, show documents modified between these two dates. For Email, show email with an Email Date between these two dates."
											/>
										</div>
										<div>
											<LabeledDatePicker
												label="Until"
												name="toDate"
												defaultValue={(() => {
													return this.state.toDate
														? new Date(
																this.state
																	.toDate
															)
														: null;
												})()}
												isClearable
												placeholderText="Present"
												handler={this.handleChange}
												hoverText="For Documents, show documents modified between these two dates. For Email, show email with an Email Date between these two dates."
											/>
										</div>
									</div>
									<div>
										<UsersDropDownSelect
											label="Locked By"
											name="usersLockFilter"
											placeholder="Any or no Users"
											isClearable
											isMulti
											isAsync
											isDisabled={false}
											defaultValue={makeDefaultUsersFilterSelection(
												this.props.users,
												this.state.usersLockFilter
											)}
											options={makeUserOptions(
												this.props.users
											)}
											handler={this.handleChange}
											hoverText="Only documents that are either 'in use' by or 'checked out' to the selected users will appear in your search results"
										/>
									</div>{" "}
								</div>
							)}
						</div>

						<div
							className="searchResultsArea"
							style={{
								marginLeft: 32,
								marginRight: 32,
								paddingTop: 8,
								width: "100%",
							}}
						>
							{this.props.searchTabs && (
								<div style={{ marginTop: 24 }}>
									<MaterialTabs
										tabs={(() => {
											const aggregations =
												this.props.aggregations;

											// Calculate counts for each record type
											const documentCount =
												aggregations
													?.uniqueDocumentIDCount
													?.value || 0;
											const emailCount =
												aggregations?.byRecordType?.buckets?.find(
													(b) => b.key === "email"
												)?.doc_count || 0;
											const noteCount =
												aggregations?.byRecordType?.buckets?.find(
													(b) =>
														b.key === "matterNote"
												)?.doc_count || 0;

											// Function to determine count for a tab based on its recordTypes
											const getCountForTab = (tab) => {
												const hasDocuments =
													tab.recordTypes.includes(
														"docs"
													) ||
													tab.recordTypes.includes(
														"docFileName"
													);
												const hasEmail =
													tab.recordTypes.includes(
														"email"
													);
												const hasNotes =
													tab.recordTypes.includes(
														"matterNote"
													);

												let count = 0;
												if (hasDocuments)
													count += documentCount;
												if (hasEmail)
													count += emailCount;
												if (hasNotes)
													count += noteCount;
												return count;
											};

											// Use searchTabs from backend and add counts dynamically
											return this.props.searchTabs.map(
												(tab) => ({
													label: `${tab.label} (${numberWithCommas(getCountForTab(tab))})`,
												})
											);
										})()}
										activeTab={this.state.activeTab}
										switchedTab={this.handleTabChange}
									/>
								</div>
							)}
							{this.props.searchError ? (
								<div style={{ color: "var(--lw-darker-red)" }}>
									{this.props.customErrorMessage ||
										"The search was not successful due to an error"}
								</div>
							) : this.props.searchResultsLoading ? null : (
								<div style={{ marginBottom: 64 }}>
									<AggregationResults
										aggregations={this.props.aggregations}
										tabAggregations={
											this.props.tabAggregations
										}
										activeTabName={
											this.props.searchTabs
												? this.props.searchTabs[
														this.state.activeTab
													]?.label
												: null
										}
										totalHits={this.props.totalHits}
										query={this.props.executedQuery}
										queryTook={this.props.queryTook}
										recordTypeMap={recordTypeMap}
										matterNames={this.props.matterNames}
										documentTypeNames={
											this.props.documentTypeNames
										}
										documentStatusNames={
											this.props.documentStatusNames
										}
										documentTagNames={
											this.props.documentTagNames
										}
										userNames={this.props.userNamesBySub}
										topMattersSearchResultsExpanded={
											this.props
												.topMattersSearchResultsExpanded
										}
										toggleTopMattersSearchResults={
											this.props
												.toggleTopMattersSearchResults
										}
									/>

									<SearchResults
										totalHits={this.props.totalHits}
										docs={this.props.docsResults}
										emails={this.props.emailResults}
										matterNotes={
											this.props.matterNoteResults
										}
										query={this.props.executedQuery}
										queryTook={this.props.queryTook}
										emailClicked={(prefix) =>
											this.props.getSignedUrlAndDownload(
												prefix,
												"email"
											)
										}
										documentTypeNames={
											this.props.documentTypeNames
										}
										documentStatusNames={
											this.props.documentStatusNames
										}
										documentTagNames={
											this.props.documentTagNames
										}
										userNames={this.props.userNamesBySub}
										loading={this.props.loading}
										activeTab={this.state.activeTab}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
const invertArrayToObject = (arr, idKey = "id", valKey = "name") => {
	var dict = {};
	arr.forEach((x) => {
		dict[x[idKey]] = x[valKey];
	});
	return dict;
};
const mapStateToProps = (state) => {
	var matterNames = { 0: "Private Firm Docs", "-1": "Public Firm Docs" };
	matterNames = {
		...matterNames,
		...invertArrayToObject(state.search.matters),
	};
	const documentTypeNames = invertArrayToObject(
		state.search.availableDocumentTypes
	);
	const documentStatusNames = invertArrayToObject(
		state.search.availableDocumentStatuses
	);
	const documentTagNames = invertArrayToObject(
		state.search.availableDocumentTags
	);
	const userNamesBySub = invertArrayToObject(
		state.search.users,
		"sub",
		"displayName"
	);
	const userSubsByID = invertArrayToObject(state.search.users, "id", "sub");
	return {
		docsResults: state.search.results.docs,
		emailResults: state.search.results.email,
		matterNoteResults: state.search.results.matterNote,
		aggregations: state.search.results.aggregations,
		tabAggregations: state.search.results.tabAggregations,
		totalHits: state.search.results.totalHits,
		queryTook: state.search.queryTook,
		searchError: state.search.error,
		customErrorMessage: state.search.customErrorMessage,
		executedQuery: state.search.executedQuery,
		helperDataLoaded: state.search.helperDataLoaded,
		mattersList: state.search.matters,
		availableDocumentStatuses: state.search.availableDocumentStatuses,
		availableDocumentTypes: state.search.availableDocumentTypes,
		availableDocumentTags: state.search.availableDocumentTags,
		fileExtensionFilterOptions: state.search.fileExtensionFilterOptions,
		users: state.search.users,
		matterNames,
		documentTypeNames,
		documentStatusNames,
		documentTagNames,
		userNamesBySub: userNamesBySub,
		userSubsByID: userSubsByID,
		currentPage: state.pagination.currentPage,
		searchResultsLoading: state.search.loading,
		lastQueryParseError: state.search.lastQueryParseError,
		searchTabs: state.search.searchTabs,
		topMattersSearchResultsExpanded:
			state.browserLocalstorage.topMattersSearchResultsExpanded,
	};
};
export default connect(mapStateToProps, {
	runSearchQuery,
	getEverythingForSearchPage,
	getSignedUrlAndDownload,
	setForcePagination,
	setComponent,
	toggleDropdownSelectShowAll,
	toggleTopMattersSearchResults,
})(Search);
